var users = [{
    "id": 1,
    "name": "Piash",
    "username": "Bret",
    "img": "https://upload.wikimedia.org/wikipedia/commons/2/2b/Lindsey_Graham%2C_official_photo%2C_113th_Congress.jpg",
    "email": "Sincere@april.biz",
    "salary": 100000,
    "address": {
        "street": "Kulas Light",
        "suite": "Apt. 556",
        "city": "Gwenborough",
        "zipcode": "92998-3874",
        "geo": {
            "lat": "-37.3159",
            "lng": "81.1496"
        }
    },
    "phone": "1-770-736-8031 x56442",
    "website": "hildegard.org",
    "company": {
        "name": "Romaguera-Crona",
        "catchPhrase": "Multi-layered client-server neural-net",
        "bs": "harness real-time e-markets"
    }
},
{
    "id": 2,
    "name": "Ervin Howell",
    "img": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Ervinyen.jpg/1200px-Ervinyen.jpg",
    "username": "Antonette",
    "email": "Shanna@melissa.tv",
    "salary": 200000,
    "address": {
        "street": "Victor Plains",
        "suite": "Suite 879",
        "city": "Wisokyburgh",
        "zipcode": "90566-7771",
        "geo": {
            "lat": "-43.9509",
            "lng": "-34.4618"
        }
    },
    "phone": "010-692-6593 x09125",
    "website": "anastasia.net",
    "company": {
        "name": "Deckow-Crist",
        "catchPhrase": "Proactive didactic contingency",
        "bs": "synergize scalable supply-chains"
    }
},
{
    "id": 3,
    "name": "Clementine Bauch",
    "img": "https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-4/images/portrait/small/avatar-s-1.jpg",
    "username": "Samantha",
    "email": "Nathan@yesenia.net",
    "salary": 150000,
    "address": {
        "street": "Douglas Extension",
        "suite": "Suite 847",
        "city": "McKenziehaven",
        "zipcode": "59590-4157",
        "geo": {
            "lat": "-68.6102",
            "lng": "-47.0653"
        }
    },
    "phone": "1-463-123-4447",
    "website": "ramiro.info",
    "company": {
        "name": "Romaguera-Jacobson",
        "catchPhrase": "Face to face bifurcated interface",
        "bs": "e-enable strategic applications"
    }
},
{
    "id": 4,
    "name": "Patricia Lebsack",
    "img": "https://pbs.twimg.com/profile_images/2692963343/151ff9f1cc1752c747834562582c4d8f_400x400.jpeg",
    "username": "Karianne",
    "email": "Julianne.OConner@kory.org",
    "salary": 500000,
    "address": {
        "street": "Hoeger Mall",
        "suite": "Apt. 692",
        "city": "South Elvis",
        "zipcode": "53919-4257",
        "geo": {
            "lat": "29.4572",
            "lng": "-164.2990"
        }
    },
    "phone": "493-170-9623 x156",
    "website": "kale.biz",
    "company": {
        "name": "Robel-Corkery",
        "catchPhrase": "Multi-tiered zero tolerance productivity",
        "bs": "transition cutting-edge web services"
    }
},
{
    "id": 5,
    "name": "Chelsey Dietrich",
    "img": "https://i.pinimg.com/280x280_RS/d1/37/b2/d137b296c03207ed30b8b93f1f19a833.jpg",
    "username": "Kamren",
    "email": "Lucio_Hettinger@annie.ca",
    "salary": 450000,
    "address": {
        "street": "Skiles Walks",
        "suite": "Suite 351",
        "city": "Roscoeview",
        "zipcode": "33263",
        "geo": {
            "lat": "-31.8129",
            "lng": "62.5342"
        }
    },
    "phone": "(254)954-1289",
    "website": "demarco.info",
    "company": {
        "name": "Keebler LLC",
        "catchPhrase": "User-centric fault-tolerant solution",
        "bs": "revolutionize end-to-end systems"
    }
},
{
    "id": 6,
    "name": "Mrs. Dennis Schulist",
    "img": "https://upload.wikimedia.org/wikipedia/commons/2/2b/Lindsey_Graham%2C_official_photo%2C_113th_Congress.jpg",
    "username": "Leopoldo_Corkery",
    "email": "Karley_Dach@jasper.info",
    "salary": 100000,
    "address": {
        "street": "Norberto Crossing",
        "suite": "Apt. 950",
        "city": "South Christy",
        "zipcode": "23505-1337",
        "geo": {
            "lat": "-71.4197",
            "lng": "71.7478"
        }
    },
    "phone": "1-477-935-8478 x6430",
    "website": "ola.org",
    "company": {
        "name": "Considine-Lockman",
        "catchPhrase": "Synchronised bottom-line interface",
        "bs": "e-enable innovative applications"
    }
},
{
    "id": 7,
    "name": "Kurtis Weissnat",
    "img": "https://avataaars.io/?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban",
    "username": "Elwyn.Skiles",
    "email": "Telly.Hoeger@billy.biz",
    "salary": 500000,
    "address": {
        "street": "Rex Trail",
        "suite": "Suite 280",
        "city": "Howemouth",
        "zipcode": "58804-1099",
        "geo": {
            "lat": "24.8918",
            "lng": "21.8984"
        }
    },
    "phone": "210.067.6132",
    "website": "elvis.io",
    "company": {
        "name": "Johns Group",
        "catchPhrase": "Configurable multimedia task-force",
        "bs": "generate enterprise e-tailers"
    }
},
{
    "id": 8,
    "name": "Nicholas Runolfsdottir V",
    "img": "https://avatars2.githubusercontent.com/u/527091?s=400&v=4",
    "username": "Maxime_Nienow",
    "salary": 100000,
    "email": "Sherwood@rosamond.me",
    "address": {
        "street": "Ellsworth Summit",
        "suite": "Suite 729",
        "city": "Aliyaview",
        "zipcode": "45169",
        "geo": {
            "lat": "-14.3990",
            "lng": "-120.7677"
        }
    },
    "phone": "586.493.6943 x140",
    "website": "jacynthe.com",
    "company": {
        "name": "Abernathy Group",
        "catchPhrase": "Implemented secondary concept",
        "bs": "e-enable extensible e-tailers"
    }
},
{
    "id": 9,
    "name": "Glenna Reichert",
    "img": "https://avatars2.githubusercontent.com/u/875913?s=400&v=4",
    "username": "Delphine",
    "salary": 150000,
    "email": "Chaim_McDermott@dana.io",
    "address": {
        "street": "Dayna Park",
        "suite": "Suite 449",
        "city": "Bartholomebury",
        "zipcode": "76495-3109",
        "geo": {
            "lat": "24.6463",
            "lng": "-168.8889"
        }
    },
    "phone": "(775)976-6794 x41206",
    "website": "conrad.com",
    "company": {
        "name": "Yost and Sons",
        "catchPhrase": "Switchable contextually-based project",
        "bs": "aggregate real-time technologies"
    }
},
{
    "id": 10,
    "name": "Clementina DuBuque",
    "img": "https://avatars2.githubusercontent.com/u/527091?s=400&v=4",
    
    "username": "Moriah.Stanton",
    "email": "Rey.Padberg@karina.biz",
    "salary": "10000",
    "address": {
        "street": "Kattie Turnpike",
        "suite": "Suite 198",
        "city": "Lebsackbury",
        "zipcode": "31428-2261",
        "geo": {
            "lat": "-38.2386",
            "lng": "57.2232"
        }
    },
    "phone": "024-648-3804",
    "website": "ambrose.net",
    "company": {
        "name": "Hoeger LLC",
        "catchPhrase": "Centralized empowering task-force",
        "bs": "target end-to-end models"
    }
},
]
export default users